// extracted by mini-css-extract-plugin
export default {"contents":"SF-z","sectionHeading":"TF-z"};